import { FC } from 'react';
import cn from 'classnames';

import { ItemsLayout, PsychicCardAppearance } from 'constants/enums';
import { Block } from 'src/__generated__/graphqlTypes';
import { BannerCarousel } from 'entities/FlatBannerContent';

import styles from './PsychicsSetMediumSizeImages.module.scss';
import type { IBannerWrapper } from './declarations';
import { useBannerImages, useEmbeddedItemPosition } from './lib/hooks';

const BannerWrapper: FC<IBannerWrapper> = ({
  banner,
  children,
  itemsLayout,
  shouldRenderBanner,
  psychicCardAppearance,
}) => {
  const isWrongConditionTile = !itemsLayout?.includes('grid');
  const gridRowStart = useEmbeddedItemPosition(psychicCardAppearance, banner?.properties);
  const bannerImages = useBannerImages(banner?.contentTypesCollection?.items as Array<Block>);

  if (!bannerImages || isWrongConditionTile || !shouldRenderBanner) {
    return <>{children}</>;
  }

  const tileStyles = {
    [styles.tile]: true,
    [styles.tileGrid2]: itemsLayout === ItemsLayout.GRID_2,
    [styles.tileGrid3]: (itemsLayout === ItemsLayout.GRID_3 || itemsLayout === ItemsLayout.GRID),
  };

  const isListAppearance = psychicCardAppearance === PsychicCardAppearance.LIST_HORIZONTAL
    || psychicCardAppearance === PsychicCardAppearance.LIST;

  return (
    <>
      <li
        style={{ gridRowStart }}
        className={cn(
          styles.injected,
          isListAppearance ? styles.list : tileStyles,
        )}
      >
        <BannerCarousel
          bannerImages={bannerImages}
          className={styles.banner}
        />
      </li>
      {children}
    </>
  );
};

export default BannerWrapper;
